import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, BulletSection, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const RstTrading = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'RST Trading',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Retail and E-Commerce',
                path: '/industries/retail-ecommerce',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-24 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.RSTLogo ? (
                <img
                  className="h-16 w-16 md:h-16 md:w-16 lg:h-20 lg:w-20 object-contain"
                  src={imagePath?.RSTLogo}
                  alt="RST Trading Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>
            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="RST Trading"
                desc="QR-Based AR Marketing Experience"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.RSTVideo && (
                <video
                  src={videoPath?.RSTVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            content="RST Trading required a modern, engaging way to showcase their product offerings without changing
            how customers traditionally interact with marketing materials. Their objective was to turn a simple QR 
            scan into a short, impactful product experience—one that clearly communicated features and benefits
            within seconds."
          />

          <Section
            title="Solution"
            content={[
              'Spatial Grid delivered a QR-based web AR marketing experience designed for instant access on any device. When users scanned the QR code on RST Trading’s marketing assets, an AI-generated digital persona appeared and introduced the product’s capabilities. Using Spatial Grid’s built-in AI plug-ins, the experience incorporated natural animations, guided narration, and smooth transitions to keep users engaged.',
            ]}
          />
          <BulletSection
            introText="To build this interactive marketing workflow, the solution leveraged several key Spatial Grid features:"
            bulletPoints={[
              'Web-based AR creation, requiring no app download',
              'Detailed interaction analytics to measure engagement and campaign performance',
              'AI-driven avatar animations for lifelike product storytelling',
              'Scene-building tools to create compelling, real-world product environments',
            ]}
            closingText="The result was an immersive marketing asset that transformed static print or digital media into an 
            interactive product showcase."
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.RST1}
                title="AR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.RST2}
                title="QR-Based WebAR Marketing"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="The QR-based AR marketing solution was delivered in just 11 days, significantly reducing 
              development time and total cost of ownership for RST Trading. The experience now enables the 
              company to convert traditional marketing touchpoints into engaging, measurable, and memorable 
              product interactions—directly from a simple QR code."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default RstTrading;
